module.exports = __webpack_public_path__ + "img/chat.a58f2748.svg";